// extracted by mini-css-extract-plugin
export default {"background":"Loader_background__U5Pmb","image":"Loader_image__IV-b1"};